import type { FaireProductEntity } from "../../entity_types/product";

export const p_4dngkxnkg9: FaireProductEntity = {
  token: "p_4dngkxnkg9",
  type: "product",
  name: "Lavender Bath Bomb - with Box Aromatherapy 5 oz",
  brandToken: "b_hcbhgx8v9w",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/392d61d4f6220e73df6069ce6ab07c6aa9f01be2041b0cd65cd3fe6eff17bca2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4de4d635cc4972083f29e55105af828e9a80dbbd37a30c0dead277b32c7d5290.jpeg",
  ],
  priceDollars: 5,
  description:
    "Experience a tranquil oasis with our Lavender Bath Bomb, designed to sooth your senses and melt away stress.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:23.050Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
